import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  Stack,
  Button,
  Container,
  Paper,
  Chip,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DaalchiniLogo from "../../assets/DaalchiniLogo.png";
import claimsucess from "../../assets/claimsucess.png";
import checkicone from "../../assets/unlock.png";
import cancel_lock from "../../assets/failed.svg";
import expiry from "../../assets/expiry.png";
import lock from "../../assets/lock.png";
import refund_redeem from "../../assets/refund_redeem.png";
import CLAIMFAILED from "../../assets/CLAIMFAILED.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { IMAGE_BASE_URL } from '../../config.js';
import { useNavigate } from "react-router-dom";
import AddEmail from "../A_Redeem/AddEmail";
import time from "../../assets/clock.png";
const Wrapper = ({ children }) => (
  <Box
      style={{background:"radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)"}}
    sx={{
      minHeight: "100vh",
      background: {
        xs: "#f3f4f6",
        sm: "linear-gradient(135deg,#eef2ff,#f8fafc)",
      },
      display: "flex",
      justifyContent: "center",
      alignItems: { xs: "stretch", sm: "center" },
      p: { xs: 0, sm: 3 },
    }}
  >
    <Container maxWidth="sm" disableGutters>
      <Box
            style={{background:"radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)"}}

        sx={{
          bgcolor: "white",
          minHeight: { xs: "100vh", sm: "auto" },
          maxHeight: { sm: "90vh" },
          overflowY: "auto",
          borderRadius: { xs: 0, sm: 4 },
          p: 3,
          boxShadow: {
            xs: "none",
            sm: "0 25px 70px rgba(0,0,0,0.12)",
          },
        }}
      >
        {children}
      </Box>
    </Container>
  </Box>
);


const Header = ({ onBackClick }) => (
  <Stack
    direction="row"
    alignItems="center"
    sx={{ mb: 3, position: "relative" }}
  >
    {/* 🔥 Circular Back Button */}
    <Box
      onClick={onBackClick}
      sx={{
        position: "absolute",
        left: 0,
        width: 36,
        height: 36,
        borderRadius: "50%",
        border: "2px solid #555",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <ArrowBackIosNewIcon
        sx={{
          fontSize: 16,
          color: "#555",
          //ml: "2px", // slight adjust for visual center
        }}
      />
    </Box>

    {/* Logo */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={DaalchiniLogo} style={{ width: "100px" }} alt="logo" />
    </Box>
  </Stack>
);


const expiredStyle = {
  background: "#FFEFEF",
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  px: 3,
  py: 0.75,
  minWidth: "70px",
  boxShadow: "none",
  color: "#404237",
  "&.Mui-disabled": {
    background: "#FFEFEF",
    color: "#404237",
    opacity: 1,
  },
};

const refundedStyle = {
  background: "#11B07826",
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  px: 3,
  py: 0.75,
  minWidth: "70px",
  boxShadow: "none",
  color: "#404237",
  "&.Mui-disabled": {
    background: "#11B07826",
    color: "#404237",
    opacity: 1,
  },
};

const ClaimCard = ({
  index_,
  data,
  lineItem,
  setIndex,
  ClaimdigitalOrder,
  HistorydigitalOrder,
  digital_orderId,
  navigate,
  setOpenAddEmail,
  setDigitalLineItemClaimId
}) => {
  const status = lineItem.claimStatus;
 

  const isClaimable = status === "UNCLAIMED";
  const isCardClickable = status === "CLAIMED";
console.log("order data", data);
  // ✅ Claim Button Click
  const handleClaim = (e, digitalLineItemClaimId,data,setOpenAddEmail ) => {
    e.stopPropagation(); // 🔥 prevent card click
    console.log("Claim button clicked with claim ID:", digitalLineItemClaimId,data.email_required,data.email_required==true);
    if (data.email_required==true) {
      setOpenAddEmail(true);
      setDigitalLineItemClaimId(digitalLineItemClaimId)
      setIndex(index_)
    }
    else{
    ClaimdigitalOrder(digitalLineItemClaimId, data);
    }
  };

  // ✅ Card Click
  const handleCardClick = (e, digitalLineItemClaimId) => {
    
    e.stopPropagation();
    console.log("Card clicked with claim ID:", digitalLineItemClaimId);
    navigate(`/digital_details?digitalLineItemClaimId=${digitalLineItemClaimId}&orderId=${digital_orderId}`);
  
  };

  return (
    <Card
        onClick={
    isCardClickable
      ? (e) => handleCardClick(e, lineItem.digitalLineItemClaimId)
      : undefined
  }
      sx={{
        mt: 2,
        p: 1.5,
        borderRadius: 2,
        border: "1px solid #e5e7eb",
        boxShadow: "none",
        cursor: isCardClickable ? "pointer" : "default",
        opacity: isCardClickable ? 0.8 : 1,
        transition: "0.2s",
        "&:hover": {
          backgroundColor: isCardClickable ? "#f9fafb" : "transparent",
        },
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">

        {/* 🔥 Image + Overlay */}
        <Box sx={{ position: "relative", width: 48, height: 48 }}>
          
          {/* Image */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#f3f4f6",
            }}
          >
            <img
              src={`${IMAGE_BASE_URL}/${data.imageUrl}`}
              alt={data.itemName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>


    {status === "FAILED" && (
            <Box
              sx={{
                position: "absolute",
                top: -6,
                left: -6,
                width: 30,
                height: 30 ,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                zIndex: 3,
                border: "2px solid white",
              }}
            >
              <img src={CLAIMFAILED} alt="lock"/>
            </Box>
          )}
          {/* 🔒 UNCLAIMED */}
          {status === "UNCLAIMED" && (
            <Box
              sx={{
                position: "absolute",
                top: -6,
                left: -6,
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                zIndex: 3,
                border: "2px solid white",
              }}
            >
              <img src={lock} alt="lock"  />
            </Box>
          )}

          {/* ✅ CLAIMED */}
          {status === "CLAIMED" && (
        <Box
    sx={{
      position: "absolute",
      top: -6,
      left: -6,
      width: 30,
      height: 30,
      borderRadius: "50%",
     /*  backgroundColor: "#fff", */
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      overflow: "hidden",
    }}
  >
     <img
      src={checkicone}  // 👉 your lock image path
      alt="lock"
      style={{
       
        
      }}
    /> 
  </Box>
          )}


          {/* ♻️ REFUNDED */}
          {status === "REFUNDED" && (
            <Box
              sx={{
                position: "absolute",
                top: -6,
                left: -6,
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3,
                border: "2px solid white",
              }}
            >
              <img src={refund_redeem} alt="refund" />
            </Box>
          )}

          {/* ⛔ EXPIRED */}
          {status === "EXPIRED" && (
            <Box
              sx={{
                position: "absolute",
                top: -6,
                left: -6,
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3,
                border: "2px solid white",
              }}
            >
              <img src={expiry} alt="expired" />
            </Box>
          )}
        </Box>

        {/* 📝 Text */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
            {data.itemName}
          </Typography>

          <Typography
            sx={{
              fontSize: 12,
              color: "#6B7280",
              mt: 0.5,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {data.itemDescription}
          </Typography>
        </Box>

        {/* 🎯 Button Logic */}
        {isClaimable && (
          <Button
            onClick={(e) => handleClaim(e,lineItem.digitalLineItemClaimId,data ,setOpenAddEmail)}
            variant="contained"
            sx={{
              background: "#00B177",
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              px: 3,
              py: 0.75,
              minWidth: "70px",
              boxShadow: "none",
              color: "#ffffff",
              "&:hover": { bgcolor: "#00B177" },
            }}
          >
            Claim
          </Button>
        )}

        {status === "EXPIRED" && (
          <Button disabled variant="contained" sx={expiredStyle}>
            Expired
          </Button>
        )}

        {status === "REFUNDED" && (
          <Button disabled variant="contained" sx={refundedStyle}>
            Refunded
          </Button>
        )}
      </Stack>
    </Card>
  );
};
export default function Cliam({ digitalorderData, ClaimdigitalOrder, HistorydigitalOrder, orderId }) {
  const navigate = useNavigate();
  const [openAddEmail,setOpenAddEmail]=useState(false)
  const [index,setIndex]=useState(null)
  const [digitalLineItemClaimId, setDigitalLineItemClaimId] = useState(null);
  const onClose=()=>{
    setOpenAddEmail(false)
}
     const params = new URLSearchParams(window.location.search);
  const digital_orderId = params.get("value");
  
  console.log(digital_orderId); // E969040105F94F66
  const handleBack = () => {
   navigate(`/`);
  };

  return (
    <Wrapper style={{background:"radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)"}}>
      <Header onBackClick={handleBack} />
        <AddEmail open={openAddEmail} onClose={onClose} digitalLineItemClaimId={digitalLineItemClaimId} digitalorderData={digitalorderData} index={index}/>

      {/* Hero Section */}
      <Stack alignItems="center" spacing={2} sx={{ mb: 4 }}>
        <img src={claimsucess} style={{ width: "90px" }} alt="success" />
        <Typography sx={{ fontWeight: 800, fontSize: 22, textAlign: "center" }}>
          You Are All Set To Claim
        </Typography>
        <Paper
          sx={{
            px: 2,
            py: 0.75,
            bgcolor: "#f0fdf400", 
            borderRadius: 2,
            display: "inline-block",
            boxShadow:"none",
          }}
        >
          <Typography sx={{ fontWeight: 500, fontSize: 13, color: "#404237" }}>
            Order ID: {digital_orderId || "n/a"}
          </Typography>
        </Paper>
        <Stack direction="row" spacing={1} alignItems="center">
          <img src={time} alt="Time" width={30} />
          <Typography sx={{ fontSize: 13, color: "#6B7280" }}>Expires in 24hr</Typography>
        </Stack>
      </Stack>

      {/* Claim Cards */}
      {console.log("digitalorderData in Cliam:", digitalorderData)}
      
      {digitalorderData?.map((item, index_) => (
        <>
        {item.isDigital==true?
        <>
    
        {item.digitalLineItemList.map((lineItem,_index) =>   
            
        <ClaimCard
          key={item.lineItemId || index}
          data={item}
          lineItem={lineItem}
          ClaimdigitalOrder={ClaimdigitalOrder}
          HistorydigitalOrder={HistorydigitalOrder}
          navigate={navigate}
          digital_orderId={digital_orderId}
          setOpenAddEmail={setOpenAddEmail}
          setDigitalLineItemClaimId={setDigitalLineItemClaimId}
          index_={index_}
          setIndex={setIndex}
         
        />
        
        
        )}
  
        </>:
        <>
       <Card
      sx={{
        mt: 2,
        borderRadius: 2,
        p: 1.5,
        boxShadow: "none",
        border: "1px solid #e5e7eb",
        opacity:   1,
        cursor: "default",
        transition: "all 0.3s ease",
        backgroundColor: "white",
        "&:hover": {
          backgroundColor:  "#fafafa",
        },
      }}
      //onClick={handleCardClick}
    >

      <Stack direction="row" spacing={2} alignItems="center">
        {/* Image Box */}
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#f3f4f6",
              flexShrink: 0,
            }}
          >
            <img
              src={`${IMAGE_BASE_URL}/${item.imageUrl}`}
              alt={item.itemName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/48?text=Logo";
              }}
            />
          </Box>
          {item.failureQuantity>0 ?<>
  <Box
    sx={{
      position: "absolute",
      top: -6,
      left: -6,
      width: 30,
      height: 30,
      borderRadius: "50%",
      //backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      //boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      overflow: "hidden",
    }}
  >
    <img
      src={cancel_lock}  // 👉 your lock image path
      alt="lock"

    />
  </Box>

</>:<>
  <Box
    sx={{
      position: "absolute",
      top: -6,
      left: -6,
      width: 30,
      height: 30,
      borderRadius: "50%",
     /*  backgroundColor: "#fff", */
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      overflow: "hidden",
    }}
  >
    <img
      src={checkicone}  // 👉 your lock image path
      alt="lock"
      style={{
       
        
      }}
    /> 
  </Box>

</>}


          {/* Check Circle on top of image for claimed items */}
     
        </Box>

        {/* Text Content */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
            {item.itemName}
          </Typography>
     <Typography
  sx={{
    color: "#6B7280",
    fontSize: 12,
    mt: 0.5,
    display: "-webkit-box",
    WebkitLineClamp: 2, // number of lines
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }}
>
  {item.itemDescription}
</Typography>
     
        </Box>

        {/* Claim Button */}
    
      </Stack>
    </Card>
        </>
        
      
      }
        </>
      ))}

      {/* Empty State */}
      {(!digitalorderData || digitalorderData.length === 0) && (
        <Box sx={{ textAlign: "center", mt: 8 }}>
          <Typography sx={{ color: "#6B7280" }}>No items available to claim</Typography>
        </Box>
      )}
    </Wrapper>
  );
}